import styled, { CSSObject } from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export interface CurrentRaceListStyleProps {
  gap: CSSObject['gap'];
  gridTemplateColumns: CSSObject['gridTemplateColumns'];
}

export const Wrapper = styled.div((props: CurrentRaceListStyleProps) =>
  mq({
    display: 'grid',
    gridTemplateColumns: props.gridTemplateColumns,
    gridGap: props.gap,
    '& > a': {
      ...hoverOpacity,
    },
  }),
);

export const ContentWrapper = styled.div((props: { isSelected: boolean }) =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    border: `2px solid ${
      props.isSelected
        ? defaultTheme.border.color.black
        : defaultTheme.border.color.white
    }`,
    borderRadius: defaultTheme.border.radius.xs,
    padding: defaultTheme.spacing.s,
    paddingRight: '0px',
  }),
);

export const Icons = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    '& > img:not(:last-of-type)': {
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const Upper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const VelodromeName = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    marginRight: defaultTheme.spacing.s,
  }),
);

export const Lower = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'flex-end',
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    minHeight: defaultTheme.font.size.s,
  }),
);

export const RaceNum = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'bold',
    marginRight: defaultTheme.spacing.xs,
  }),
);

export const ReleaseStatus = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'normal',
  }),
);

export const EmptyText = styled.span(() =>
  mq({
    display: 'block',
    textAlign: 'center',
    padding: `${defaultTheme.spacing.l} 0 40px`,
  }),
);
